import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { generalApiModuleDescriptionLenses } from 'root/src/client/logic/api/lenses'

const { viewOnEnterActions } = generalApiModuleDescriptionLenses

export default (state, { moduleId }) => viewOnEnterActions(moduleId, moduleDescriptions)
